var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid serve-container",attrs:{"id":"app2"}},[_c('div',{staticClass:"serve bg"}),_c('Serve')],1)}
var staticRenderFns = []

export { render, staticRenderFns }